/**
 * @desc getPaymentBankInfoList
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<Array<defs.rms.PaymentBankResponseDto>>;
export function request(
  body: defs.rms.PaymentBankRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/paymentBankInfo/getPaymentBankInfoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
